var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E1F1D",
    d: "M13.599.133A2.666 2.666 0 0 1 16.265 2.8v10.624A2.667 2.667 0 0 1 13.6 16.09H2.975a2.667 2.667 0 0 1-2.667-2.667V2.8A2.667 2.667 0 0 1 2.975.133zm-.235 12.215v-8.47a.84.84 0 0 0-.841-.842h-8.47a.84.84 0 0 0-.843.841v8.471c0 .465.377.842.842.842h8.471a.84.84 0 0 0 .841-.841m-6.77-2.06a.484.484 0 0 1-.484-.486v-3.38c0-.269.217-.486.483-.486H9.98c.267 0 .483.217.483.485v3.381a.484.484 0 0 1-.483.486z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.308.133h16v16h-16z"
  })))));
};
export default SvgSquare;